enum AccessRadiusSearchPageElementEnum {
  AccessRadiusSearch = "accessRadiusSearch",
  RadiiOne = "radiiOne",
  RadiiTwo = "radiiTwo",
  RadiiThree = "radiiThree",
  RadiiFour = "radiiFour",
  RadiiFive = "radiiFive",
}

export { AccessRadiusSearchPageElementEnum };
